// madlibs.js
// Works whether the sentence and word banks are in the same block
// or spread across separate Shopify blocks — only requires that
// data-slot attributes match between .ml-blank and .ml-pills elements.

(function () {

  // Track which pill is currently selected per slot
  var selected = {};

  function init() {
    document.querySelectorAll('.ml-pills').forEach(function (group) {
      var slot = group.dataset.slot;

      group.querySelectorAll('.ml-pill').forEach(function (pill) {
        pill.addEventListener('click', function () {
          var blank = document.querySelector('.ml-blank[data-slot="' + slot + '"]');
          if (!blank) return;

          if (pill.classList.contains('ml-selected')) {
            // Clicking the active pill deselects it and clears the blank
            pill.classList.remove('ml-selected');
            blank.textContent = '';
            selected[slot] = null;
          } else {
            // Deselect whichever pill was previously selected for this slot
            if (selected[slot]) {
              selected[slot].classList.remove('ml-selected');
            }
            // Select the new pill and fill the blank
            pill.classList.add('ml-selected');
            selected[slot] = pill;
            blank.textContent = pill.textContent;
          }
        });
      });
    });
  }

  // Run after DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();

// quiz.js
// Consent quiz — select any button at any time to update
// the result. No reset needed; every button is always clickable.

(function () {

  var RESPONSES = {
    stop:    '"Can we stop?" is someone withdrawing from a situation — it\'s the opposite of consent. Stop immediately, no questions asked.',
    dunno:   '"I dunno" is not consent. Uncertainty or ambiguity means pause, check in, and wait for a clear and enthusiastic answer.',
    no:      '"No" is unambiguous — but it still belongs on this list. Every option here communicates that consent is not present.',
    messed:  '"I\'m kinda messed up right now" means the person is not in a position to give informed consent. The only correct response is to stop.',
    guess:   '"I guess" is not consent. A hesitant or pressured yes is not a yes. If it\'s not an enthusiastic yes, treat it as a no.',
    slow:    '"Let\'s slow down" is a boundary being set. Respect it immediately — slow down or stop, and check in before continuing.',
    silence: 'Silence is not consent. The absence of a no is not a yes. Always look for an active, clear, enthusiastic response.',
    all:     'All of the above — every single one. "Can we stop?", uncertainty, silence, hesitation — none of these are consent. If it\'s not a clear, enthusiastic yes, it\'s a no.',
  };

  function init() {
    var buttons = document.querySelectorAll('#quizButtons .quiz-btn');
    var result  = document.getElementById('quizResult');

    if (!buttons.length || !result) return;

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        // Update result text
        result.textContent = RESPONSES[btn.dataset.response] || '';
        result.classList.add('quiz-show');

        // Mark result box green if "all of the above" was selected
        result.classList.toggle('quiz-result-correct', btn.dataset.response === 'all');

        // Move active highlight to clicked button, dim the rest
        buttons.forEach(function (b) {
          b.classList.remove('quiz-active', 'quiz-dimmed');
          if (b === btn) {
            b.classList.add('quiz-active');
          } else {
            b.classList.add('quiz-dimmed');
          }
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();